import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './helper/guards/auth-guard-service.service';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { ProgramSettingsComponent } from './program-settings/program-settings.component'
import { NewProjectComponent} from './new-project/new-project.component';
import { ProjectComponent } from './project/project.component';

import { CustomerInfoComponent } from './project/customer-info/customer-info.component';
import { SiteInfoComponent } from './project/site-info/site-info.component';
import { ContaminationComponent } from './project/contamination/contamination.component';
import { SolutionComponent } from './project/solution/solution.component';
import { ResultComponent } from './project/result/result.component';
import { ReportsComponent } from './project/reports/reports.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  //{ path: '', redirectTo: 'home', pathMatch: 'full' , canActivate: [AuthGuardService] },
  { path: 'login', component:LoginComponent },
  { path: 'home', component:HomeComponent },
  { path: 'userInfo', component: UserInfoComponent, canActivate: [AuthGuardService] },
  { path: 'progSettings', component: ProgramSettingsComponent, canActivate: [AuthGuardService] },
  { path: 'newProject', component: NewProjectComponent, canActivate: [AuthGuardService] },
  { path: 'project/:projectID', component: ProjectComponent, canActivate: [AuthGuardService] },

  { path: 'projectedit/:projectID', component: ProjectComponent, canActivate: [AuthGuardService] },
  { path: 'importxml/:projectID', component: ProjectComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    BrowserModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
